import { HTMLText } from 'components/Share/HtmlText'
import { EyeOff } from 'icons/EyeOff'
import { EyeSlash } from 'icons/EyeSlash'
import { useState } from 'react'
import { Form, FormControlProps, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FormattedMessage } from 'react-intl'
import { StyleInputEye, StyledFormControl, StyleInfoIcon, StyleTooltip } from './FormInput.styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { theme } from 'core/skins/BMW/theme'
interface IFormInput extends FormControlProps {
  name: string
  type: string
  placeholder?: string
  className?: string
  error?: any
  children?: any
  label?: string
  infoIcon?: string
  maxLength?: number
  onBlur?: (e: any) => void
  autoComplete?: string
  'data-lpignore'?: string
  isChangeEyeIcon?: boolean
}

export const FormInput = ({
  name,
  type,
  placeholder,
  className,
  error,
  children,
  label,
  infoIcon,
  as,
  maxLength,
  isChangeEyeIcon,
  ...props
}: IFormInput) => {
  const [showPassword, setShowPassword] = useState<boolean>(false)

  const isLoginPage = () => {
    return name === 'username' || name === 'password'
  }

  return (
    <>
      {type === 'password' ? (
        <Form.Group className={`mb-3 ${className}`} controlId={name}>
          <Form.Label>
            <FormattedMessage id={label} />
          </Form.Label>
          {infoIcon && (
            <StyleInfoIcon>
              <IconTooltip id={name} title={infoIcon}>
                <FontAwesomeIcon className="eye-icon" icon={faInfoCircle} color={theme.colors.primary} />
              </IconTooltip>
            </StyleInfoIcon>
          )}
          <InputGroup hasValidation className="justify-content-end">
            <StyledFormControl
              type={showPassword ? 'text' : 'password'}
              placeholder={placeholder}
              name={name}
              {...props}
            />
            {props?.value && (
              <StyleInputEye
                isChangeEyeIcon={isChangeEyeIcon}
                onClick={() => {
                  setShowPassword(!showPassword)
                }}
              >
                {showPassword ? (
                  <EyeOff height="2rem" width="2rem" color="#878787" />
                ) : (
                  <EyeSlash height="2rem" width="2rem" color="#878787" />
                )}
              </StyleInputEye>
            )}
            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
          </InputGroup>
        </Form.Group>
      ) : (
        <Form.Group className={`mb-3 ${className}`} as={as} controlId={name}>
          <Form.Label>{label}</Form.Label>
          {isLoginPage() ? (
            <StyledFormControl type={type} placeholder={placeholder} name={name} {...props} />
          ) : (
            <Form.Control type={type} placeholder={placeholder} name={name} {...props} />
          )}
          {children}
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        </Form.Group>
      )}
    </>
  )
}

export const IconTooltip = ({ id, children, title }) => {
  return (
    <OverlayTrigger
      placement="right"
      overlay={
        <StyleTooltip id={id}>
          <HTMLText value={title} />
        </StyleTooltip>
      }
    >
      {children}
    </OverlayTrigger>
  )
}
